import {MESSAGE_CONTENT_TYPE_SYSTEM_INFO, MESSAGE_CONTENT_TYPE_SYSTEM_ERROR} from "../../../../constants";
import cx from "classnames";
import {useTranslation} from 'react-i18next';

const MessageDirectionSystem = ({message}) => {
    const {t, i18n} = useTranslation();

    const isContentTypeSystemInfo = message.content_type === MESSAGE_CONTENT_TYPE_SYSTEM_INFO;
    const isContentTypeSystemError = message.content_type === MESSAGE_CONTENT_TYPE_SYSTEM_ERROR;

    return <div className="i-chats-dialogue-content-message i-chats-dialogue-content-message__equal-indentation" key={message.id}>
        <div className={cx("i-chats-dialogue-content-message-notice", {
            'i-chats-dialogue-content-message-notice-warning': isContentTypeSystemInfo,
            'i-chats-dialogue-content-message-notice-danger': isContentTypeSystemError,
        })}>
            <div className="i-chats-dialogue-content-message-text">
                <span>{t(message.text)}</span>
            </div>
        </div>
    </div>
}

export default MessageDirectionSystem;